<template>
    <div class="nursinglog">
        <el-row>
            <el-tabs v-model="groupActiveName" @tab-click="handleClickGroup">
                <el-tab-pane v-for="(item, index) in groupTabsList" :label="item.name" :name="item.nursingGroupId"
                    :key="index">
                    <el-row>
                        <el-row class="row-title">
                            <el-col :span=2 align=right style="margin-right:5px;">
                                <kt-button label="上一天" type="primary" @click="handlePrevDay" />
                            </el-col>
                            <el-col :span=4>
                                <el-date-picker :editable="false" :clearable="false" v-model="dateValue" type="date"
                                    value-format="yyyy-MM-dd" @change="changeDate" placeholder="请选择日期">
                                </el-date-picker>
                            </el-col>
                            <el-col :span=2>
                                <kt-button label="下一天" type="primary" @click="handleNextDay" /></el-col>
                        </el-row>
                    </el-row>
                    <el-row>
                        <el-tabs class="group-isactive" v-model="activeName" @tab-click="handleClickServiceType">
                            <el-tab-pane v-for="(item, index) in tabsList" :label="item.label" :name="item.name"
                                :key="index">
                                <!-- <ul v-if="item.name == 'first'" class="room clearfix">
                                    <li class="roomitem" v-for="(item, index) in roomList" :key="index">
                                        <div class="changfx">
                                            <h5>{{ item.roomNo }}</h5>
                                            <img src="@/assets/beadhouse/xiu.png" alt="" @click="handleEditRoom"
                                                v-show="false">
                                        </div>
                                        <div class="classDiv">
                                            <div class="line_bh" v-for="(temp, i) in item.omcShiftsList" :key="i">
                                                <h4 class="shiftname">{{ temp.name }}:</h4>
                                                <div class="qq_width" v-for="(user, j) in temp.userList" :key="j">
                                                    <h4 :title="user.realname" class="realname">{{ user.realname }}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul> -->
                                <el-row v-if="item.name == 'second'">
                                    <el-row
                                        style="height:54px;line-height:54px;background:#F9F7FA;border:1px #F1EFF2 solid;">
                                        <el-col>
                                            <img src="@/assets/beadhouse/juxing.png" alt=""
                                                style="vertical-align:middle;margin:0 10px 0 10px;">
                                            <span style="font-size:16px;">{{ nursingLog.basicInformation }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-table style="width:100%" :data="foodServiceList"
                                            :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
                                            :row-style="tableRowStyle" :header-cell-style="tableHeaderColor"
                                            @cell-click="handleCellClickFoodService">
                                            <el-table-column :label="nursingLog.category" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.typeName }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="nursingLog.food" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.food }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="nursingLog.notEat" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <div :class="{ hoverColor: isTrue }"
                                                        style="height:65px;line-height:65px;">
                                                        <div style="margin-left: 10px;padding-top:5px;">{{ scope.row.oldName
                                                        }}</div>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="nursingLog.specialDiet" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <div style="height:65px;">
                                                        <div style="margin-left: 10px;padding-top:5px;">
                                                            <el-input v-model.trim="scope.row.dietRecords"
                                                                :disabled="foodDisabled" type="textarea" :rows=2
                                                                auto-complete="off" placeholder=""
                                                                style="width:95%"></el-input>
                                                        </div>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-row>
                                    <div align="center" style="margin-top:30px;">
                                        <el-button type="warning" :size="size" v-show="false" v-if="foodShow"
                                            @click.native="handleFoodEdit">编辑</el-button>
                                        <el-button type="primary" :size="size" v-show="false" v-if="!foodShow"
                                            @click.native="handleFoodSure">确定</el-button>
                                    </div>
                                </el-row>
                                <el-row v-if="item.name == 'third'">
                                    <el-row style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{
                                        nursingLog.disinfectionServices }}</el-row>
                                    <el-row>
                                        <el-table style="width:100%" :data="disinfectionServices" :row-style="tableRowStyle"
                                            :header-cell-style="tableHeaderColor" :span-method="objectSpanMethod">
                                            <el-table-column :label="nursingLog.category" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.typeName }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="nursingLog.method" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <el-select v-model="scope.row.method" :disabled="selectDisabled"
                                                        style="width:80%" :placeholder="nursingLog.pleaseChoose">
                                                        <el-option label="请选择" :value="0"></el-option>
                                                        <el-option v-for="item in methodOptions" :key="item.value"
                                                            :label="item.label" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="nursingLog.reagent" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <el-select v-model="scope.row.reagent" :disabled="selectDisabled"
                                                        style="width:80%" :placeholder="nursingLog.pleaseChoose">
                                                        <el-option label="请选择" :value="0"></el-option>
                                                        <el-option v-for="item in reagentOptions" :key="item.value"
                                                            :label="item.label" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="nursingLog.time" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <el-select v-model="scope.row.time" :disabled="selectDisabled"
                                                        style="width:80%" :placeholder="nursingLog.pleaseChoose">
                                                        <el-option v-for="item in timeOptions" :key="item.value"
                                                            :label="item.label" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="nursingLog.principal" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <el-select v-model="scope.row.person" v-if="!selectDisabled"
                                                        :disabled="selectDisabled" style="width:80%"
                                                        :placeholder="nursingLog.pleaseChoose">
                                                        <el-option v-for="item in personOptions" :key="item.userId"
                                                            :label="item.realName" :value="item.userId">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- by gu0 2019-11-23-16:24添加 -->
                                                    <el-input v-model.trim="scope.row.userName" maxlength="64"
                                                        v-if="selectDisabled" :disabled="selectDisabled" auto-complete="off"
                                                        placeholder="" style="width:80%"></el-input>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-row>
                                    <div align="center" style="margin-top:30px;">
                                        <el-button type="warning" :size="size" v-show="false" v-if="disinfectionShow"
                                            @click.native="handleDisinfectionEdit">编辑</el-button>
                                        <el-button type="primary" :size="size" v-show="false" v-if="!disinfectionShow"
                                            @click.native="handleDisinfectionSure">确定</el-button>
                                    </div>
                                </el-row>
                                <el-row
                                    v-if="item.name == 'four' || item.name == 'five' || item.name == 'six' || item.name == 'seven'">
                                    <el-row v-if="item.name == 'four'"
                                        style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{
                                            nursingLog.basicCareRecord }}</el-row>
                                    <el-row v-if="item.name == 'five'"
                                        style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{
                                            nursingLog.oralCareRecord }}</el-row>
                                    <el-row v-if="item.name == 'six'"
                                        style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{
                                            nursingLog.pressureUlcerCareRecord }}</el-row>
                                    <el-row v-if="item.name == 'seven'"
                                        style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{
                                            nursingLog.rehealthyTraining }}</el-row>
                                    <el-row>
                                        <!-- 表格data的值 用三元运算符多层嵌套 判断应该取哪一个数组-->
                                        <el-table style="width:100%" border
                                            :data="item.name == 'four' ? basicNursing : (item.name == 'five' ? mouthNursing : (item.name == 'six' ? pressureSoresNursing : recoveryNursing))"
                                            :row-style="tableRowStyle" :header-cell-style="tableHeaderColor"
                                            @cell-click="handleCellClickAllNursing">
                                            <el-table-column :label="nursingLog.oldName" align="center" min-height="100"
                                                min-width="300" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <div :class="{ hoverColorSynthesis: isTrueSynthesis }"
                                                        style="height:65px;line-height:65px;">
                                                        <div style="margin-left: 10px;padding-top:5px;">{{ scope.row.oldName
                                                        }}</div>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="nursingLog.principal" align="center" min-height="100"
                                                min-width="100" :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <el-select v-model="scope.row.person" v-if="!selectDisabledAllNursing"
                                                        :disabled="selectDisabledAllNursing" style="width:80%"
                                                        :placeholder="nursingLog.pleaseChoose">
                                                        <el-option v-for="item in personOptions" :key="item.userId"
                                                            :label="item.realName" :value="item.userId">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- by gu0 2019-11-23-16:24添加 -->
                                                    <el-input v-model.trim="scope.row.userName" maxlength="64"
                                                        v-if="selectDisabledAllNursing" :disabled="selectDisabledAllNursing"
                                                        auto-complete="off" placeholder="" style="width:80%"></el-input>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-row>
                                    <div align="center" style="margin-top:30px;">
                                        <el-button type="warning" :size="size" v-show="false" v-if="allNursingShow"
                                            @click.native="handleAllNursingEdit">编辑</el-button>
                                        <el-button type="primary" :size="size" v-show="false" v-if="!allNursingShow"
                                            @click.native="handleAllNursingSure">确定</el-button>
                                    </div>
                                </el-row>
                            </el-tab-pane>
                        </el-tabs>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </el-row>
        <!-- 房间分配的dialog模态框-->
        <el-dialog :title="nursingLog.roomAllocation" width="50%" :visible.sync="dialogVisibleRoomAllocation"
            :close-on-click-modal="false">
            <el-form :model="roomAllocation" label-width="50px" :rules="roomAllocationRules" ref="roomAllocation"
                label-position="right">
                <el-row style="width:80%;margin:0 auto;">
                    <el-form-item :label="nursingLog.classes" prop="monitorItemName">
                        <el-select v-model="roomAllocation.classes" @change="handleSelectClasses"
                            :placeholder="nursingLog.pleaseSelectShift" style="width:35%">
                            <el-option v-for="item in classesOptions" :key="item.omcShifts.id" :label="item.omcShifts.name"
                                :value="item.omcShifts.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row style="width:80%;margin:0 auto;">
                    <el-col :span=9 :offset=1>
                        <el-row class="roomInfo">
                            <el-row class="roomInfoText">
                                {{ nursingLog.staffName }}
                            </el-row>
                            <el-row class="roomInfoContent">
                                <el-col v-for='(item, index) in nursingWithRoomList' :key="index">
                                    <el-col :span=18 :offset=6 class="buildingName">
                                        <span v-if="item.showRoomImg" style="float:left;width:5%"><img
                                                src="@/assets/beadhouse/jian.png" alt="" class="handedness"
                                                @click="handleRoomMinusImg(index)"></span>
                                        <span v-else><img src="@/assets/beadhouse/jia.png" alt="" class="handedness"
                                                @click="handleRoomAddImg(index, item.userid)"></span>
                                        <span style="float:right;width:86%">
                                            <el-checkbox-group v-model="checkedNursing" @change="handleCheckedNursing">
                                                <el-checkbox :label="item.userid">{{ item.realname }}</el-checkbox>
                                            </el-checkbox-group>
                                        </span>
                                    </el-col>
                                    <el-col :class="{ roomListA: item.isRoomTrueA, roomListB: item.isRoomTrueB }">
                                        <el-checkbox-group v-model="checkedRoom" @change="handleCheckedRoom"
                                            class="checkboxRoom">
                                            <el-checkbox v-for="(room, i) in item.roomList" :label="room.roomId" :key="i"
                                                :title="room.roomNo" class="roomNo">{{ room.roomNo }}</el-checkbox>
                                        </el-checkbox-group>
                                    </el-col>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-col>
                    <el-col :span=3 :offset=1 class="btn">
                        <el-row class="addBtn"><el-button v-show="addBtnShow" :size="size" type="success"
                                @click="submitFormAddRoom">添加</el-button></el-row>
                        <el-row class="deleteBtn"><el-button v-show="deleteBtnShow" :size="size"
                                @click="submitFormDeleteRoom">删除</el-button></el-row>
                    </el-col>
                    <el-col :span=9 :offset=1>
                        <el-row class="roomInfo">
                            <el-row class="roomInfoText">
                                {{ nursingLog.responsibleRoom }}
                            </el-row>
                            <el-row class="roomInfoContent">
                                <el-checkbox-group v-model="chooseRoom" @change="handleChooseRoomList"
                                    style="width:65%;margin:10px auto;">
                                    <el-checkbox v-for="(item, i) in allNursingRoom" :label="item.roomId" :key="i"
                                        style="margin-top:10px;">{{ item.roomNo }}</el-checkbox>
                                </el-checkbox-group>
                            </el-row>
                        </el-row>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <!-- 点击膳食服务表格的单个单元格弹出dialog模态框-->
        <el-dialog :title="nursingLog.chooseOldMan" width="45%" :visible.sync="dialogVisibleAddOldman"
            :close-on-click-modal="false">
            <el-form :model="addOldman" label-width="100px" :rules="addOldmanRules" ref="addOldman" label-position="right">
                <el-row style="width:80%;margin:0 auto;">
                    <el-row
                        style="height:54px;line-height:54px;border:1px #F1EFF2 solid;text-align:center;font-size:16px;">{{
                            nursingLog.oldManList }}</el-row>
                    <el-row style="min-height:100px;border:1px #F1EFF2 solid;border-top:none;">
                        <el-checkbox-group v-model="checkedOldMan" @change="handleCheckedOldMan"
                            style="width:65%;margin:10px auto;">
                            <el-checkbox v-for="(item, index) in oldmanCheckboxs" :label="item.oldmanId" :key="index"
                                style="margin-top:10px;">{{ item.oldName }}</el-checkbox>
                        </el-checkbox-group>
                    </el-row>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button :size="size" @click.native="dialogVisibleAddOldman = false">取消</el-button>
                <el-button :size="size" type="primary" @click.native="submitFormAddOldman"
                    :loading="addOldmanLoading">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import KtTable from "@/components/KtTable"
import KtButton from "@/components/KtButton"
import util from '@/utils/util.js'
export default {
    name: 'NursingLogManagement',
    components: { KtTable, KtButton },
    data() {
        return {
            groupActiveName: '',
            groupTabsList: [],
            nursingLog: {
                basicInformation: "基本信息",
                category: "类别",
                food: "食物",
                notEat: "未用餐老人",
                specialDiet: "特殊饮食记录情况",
                disinfectionServices: "消毒服务",
                method: "方法",
                pleaseChoose: "请选择",
                reagent: "试剂",
                time: "时间",
                principal: "负责人",
                basicCareRecord: "基础护理记录",
                oralCareRecord: "口腔护理记录",
                pressureUlcerCareRecord: "压疮护理记录",
                rehealthyTraining: "康复训练",
                oldName: "老人姓名",
                roomAllocation: "房间分配",
                classes: "班次:",
                pleaseSelectShift: "请选择班次",
                chooseOldMan: "选择老人",
                oldManList: "老人列表",
                staffName: "员工姓名",
                responsibleRoom: "负责房间"
            },//引入 lang 里面的字符串资源,
            nursingGroupId: '',//护工组id
            isTrue: false,//未用餐老人的表格单元格的hover颜色
            loading: true,
            size: 'medium',//按钮的尺寸
            dateValue: util.formatDate.format(new Date(), 'yyyy-MM-dd'),
            activeName: 'second',
            tabsList: [
                // { label: '房间签到', name: 'first' },
                { label: '膳食服务', name: 'second' },
                { label: '消毒服务', name: 'third' },
                { label: '基础护理', name: 'four' },
                { label: '口腔护理', name: 'five' },
                { label: '压疮护理', name: 'six' },
                { label: '康复训练', name: 'seven' },
            ],
            addBtnShow: true,//添加按钮
            deleteBtnShow: true,//删除按钮
            checkedNursing: [],//左边被选中的护工
            checkedRoom: [],//左边被选中的房间
            nursingWithRoomList: [],//左边的护工以及负责的房间
            newAllNursingRoomList: [],//左边的所有的护工以及负责的房间的处理后数据 例 [{userId:1,realName:"前端",roomId:"123"},{userId:2,realName:"前端2",roomId:"123"}]
            chooseRoom: [],//右边被选取的房间
            allNursingRoom: [],//右边该班组的护工组房间
            roomList: [],//房间签到房间数据
            newNursingList: [],//用来存放被选取的护工  例 [{userId:1,realName:"前端"},{userId:2,realName:"前端2"}]
            //房间分配的dilaog配置
            dialogVisibleRoomAllocation: false,
            roomAllocation: {
                classes: "",
            },
            roomAllocationRules: {},
            roomAllocationLoading: false,
            classesOptions: [],//班次集合
            //膳食服务的初始化数据
            foodServiceList: [
                { type: 1, typeName: "早餐", food: "", oldName: "", oldmanId: "", dietRecords: "", oldmanIdNew: "" },
                { type: 2, typeName: "中餐", food: "", oldName: "", oldmanId: "", dietRecords: "", oldmanIdNew: "" },
                { type: 3, typeName: "晚餐", food: "", oldName: "", oldmanId: "", dietRecords: "", oldmanIdNew: "" }
            ],
            foodDisabled: true,
            foodShow: true,
            //膳食服务表格 点击单元格的dialog配置
            dialogVisibleAddOldman: false,
            addOldman: {},
            addOldmanRules: {},
            addOldmanLoading: false,
            checkedOldMan: [],//被选中的老人
            oldmanCheckboxs: [],//班组所有的老人
            oldName: "",//老人姓名的字符串逗号拼接
            checkOldmanId: "",//老人id的字符串-拼接
            //消毒服务的初始数据
            disinfectionServices: [
                { type: 1, typeName: "消毒柜", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 1, typeName: "消毒柜", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 1, typeName: "消毒柜", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 1, typeName: "消毒柜", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                // {type:1,typeName:"消毒柜",method:0,reagent :0,time:0,person:0,personNew:"",userName:"请选择"},
                { type: 2, typeName: "洗抹", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 2, typeName: "洗抹", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 2, typeName: "洗抹", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 2, typeName: "洗抹", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                // {type:2,typeName:"洗抹",method:0,reagent :0,time:0,person:0,personNew:"",userName:"请选择"},
                { type: 3, typeName: "其他", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 3, typeName: "其他", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 3, typeName: "其他", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 3, typeName: "其他", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                // {type:3,typeName:"其他",method:0,reagent :0,time:0,person:0,personNew:"",userName:"请选择"}
            ],
            methodOptions: [],//消毒服务  方法
            reagentOptions: [],//消毒服务 试剂
            timeOptions: [],//消毒服务 时间
            personOptions: [{ realName: "请选择", userId: 0 }],//消毒服务 负责人
            selectDisabled: true,
            disinfectionShow: true,
            //基础护理的初始化数据
            basicNursing: [
                { id: 1, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 2, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 3, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 4, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 5, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 6, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 7, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
            ],
            //口腔护理的初始化数据
            mouthNursing: [
                { id: 1, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 2, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 3, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 4, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 5, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 6, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 7, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
            ],
            //压疮护理的初始化数据    
            pressureSoresNursing: [
                { id: 1, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 2, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 3, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 4, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 5, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 6, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 7, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
            ],
            //康复训练的初始化数据
            recoveryNursing: [
                { id: 1, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 2, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 3, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 4, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 5, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 6, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 7, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
            ],
            selectDisabledAllNursing: true,
            allNursingShow: true,
            isTrueSynthesis: false,//基础，压疮，口腔，康复 老人姓名的表格单元格的hover颜色
        }
    },
    methods: {
        /* 
            点击切换护工组
        */
        handleClickGroup(tab, event) {
            console.log(tab, event)
            console.log(this.groupActiveName)
            this.nursingGroupId = tab.name;//点击的时候获取护工组id
            console.log(this.nursingGroupId, '----');
            this.queryFood();//查询食物
            this.queryNursingLog();//刷新表格数据
            this.queryRoom();//查询房间和排班方案信息
            this.selectRooms();//查询护工组负责房间
            this.selectById();//查询该护工组护工
        },
        /* 
            选项卡点击事件 切换服务类型
        */
        handleClickServiceType(tab, event) {
            console.log(tab, event)
            console.log(this.activeName)
        },

        /* 
           时间选择框的change事件
       */
        changeDate(val) {
            this.queryFood();//查询食物
            this.queryNursingLog();//刷新表格数据
            this.queryRoom();//查询房间和排班方案信息
        },

        /* 
            上一天
        */
        handlePrevDay() {
            // 获得当前日期
            var doday = new Date(this.dateValue);
            console.log(doday)
            doday = Date.parse(doday);
            console.log(doday);
            // 将当前日期减去1天的时间
            doday = doday - (1000 * 60 * 60 * 24);
            // timeFormat()日期格式化
            var nowDate = util.formatDate.format(new Date(doday));
            console.log(nowDate)
            // 获得value
            this.dateValue = nowDate;
            console.log(this.dateValue);
            this.queryFood();//查询食物
            this.queryNursingLog();//刷新表格数据
            this.queryRoom();//查询房间和排班方案信息
            if (this.activeName == 'first') {
                this.defaultSelectClasses();
            }
        },

        /* 
            下一天
        */
        handleNextDay() {
            // 获得当前日期
            var doday = new Date(this.dateValue);
            console.log(doday)
            doday = Date.parse(doday);
            console.log(doday);
            // 将当前日期加上1天的时间
            doday = doday + (1000 * 60 * 60 * 24);
            // timeFormat()日期格式化
            var nowDate = util.formatDate.format(new Date(doday));
            console.log(nowDate)
            // 获得value
            this.dateValue = nowDate;
            console.log(this.dateValue);
            this.queryFood();//查询食物
            this.queryNursingLog();//刷新表格数据
            this.queryRoom();//查询房间和排班方案信息
            if (this.activeName == 'first') {
                this.defaultSelectClasses();
            }
        },



        /* ----------------------------------- 房间签到------------------------------------ */

        /* 
            点击动态生成的房间块的编辑按钮
        */
        handleEditRoom() {
            console.log("-=====");
            this.addBtnShow = true,//重置添加按钮状态
                this.deleteBtnShow = true,//重置删除按钮状态
                this.checkedNursing = [];//每次打开清空左边的护工数据
            this.checkedRoom = [];//每次打开清空左边的房间数据
            this.chooseRoom = [];//每次打开清空右边的房间数据
            this.roomAllocation.classes = "";//每次打开时清空数据，防止上一次的数据残留
            this.dialogVisibleRoomAllocation = true;
            this.defaultSelectClasses();
            //延迟加载  否则dialog左边护工和房间的数据无法正常显示
            this.$nextTick(() => {
                setTimeout(() => {
                    this.queryRoomDetail();
                }, 500)
            })
        },

        /* 
            左边护工的checkbox的change事件
        */
        handleCheckedNursing(val) {
            console.log(val);
            this.checkedNursing = val;
            console.log(this.checkedNursing, this.nursingWithRoomList);
            this.newNursingList = [];
            this.checkedNursing.forEach(item => {
                this.nursingWithRoomList.forEach(temp => {
                    var itemObj = {};
                    if (item == temp.userid) {
                        itemObj.userId = temp.userid;
                        itemObj.realName = temp.realname;
                        this.newNursingList.push(itemObj);
                    }
                })
            })
            console.log(this.newNursingList);
        },

        /* 
            左边负责房间的checkbox的change事件
        */
        handleCheckedRoom(val) {
            console.log(val);
            this.checkedRoom = val;
            this.addBtnShow = this.checkedRoom.length > 0 ? false : true;//当左边的房间 有房间被选中时 添加按钮隐藏
        },

        /* 
            房间分配的dialog中员工姓名减号小图标的点击
        */
        handleRoomMinusImg(index) {
            console.log(index)
            //点击动态的修改状态
            this.nursingWithRoomList[index].showRoomImg = !this.nursingWithRoomList[index].showRoomImg;
            this.nursingWithRoomList[index].isRoomTrueA = !this.nursingWithRoomList[index].isRoomTrueA;
            this.nursingWithRoomList[index].isRoomTrueB = !this.nursingWithRoomList[index].isRoomTrueB;
            this.$set(this.nursingWithRoomList, index, this.nursingWithRoomList[index]);
        },

        /* 
            房间分配的dialog中员工姓名加号小图标的点击
        */
        handleRoomAddImg(index, userid) {
            console.log(index, userid);
            //点击动态的修改状态
            this.nursingWithRoomList[index].showRoomImg = !this.nursingWithRoomList[index].showRoomImg;
            this.nursingWithRoomList[index].isRoomTrueA = !this.nursingWithRoomList[index].isRoomTrueA;
            this.nursingWithRoomList[index].isRoomTrueB = !this.nursingWithRoomList[index].isRoomTrueB;
            this.$set(this.nursingWithRoomList, index, this.nursingWithRoomList[index]);
            this.nursingWithRoomList.forEach((item, i) => {
                if (index != i) {
                    item.showRoomImg = false;
                    item.isRoomTrueA = false
                    item.isRoomTrueB = true
                }
            })
        },

        /* 
            查询房间
        */
        queryRoom() {
            let params = {};
            params.nursingGroupId = this.nursingGroupId * 1;
            params.date = this.dateValue;
            console.log(params);
            this.roomList = [];//清空数据 防止数据累加
            // this.$postJson('omc/roomAssignment/selectAll', params).then(res => {
            //     console.log(res);
            //     if (res.code == 200) {
            //         if (res.result != null && res.result.length > 0) {
            //             res.result.forEach(item => {
            //                 let roomObj = {};
            //                 roomObj.roomId = item.roomId;
            //                 roomObj.roomNo = item.roomNo;
            //                 roomObj.omcShiftsList = item.omcShiftsList;
            //                 this.roomList.push(roomObj);
            //             })
            //             console.log(this.roomList, "=======")
            //         }
            //     } else {
            //         this.$message({ message: res.message, type: "error" })
            //     }
            // })
        },

        /* 
            查询房间详情
        */
        queryRoomDetail() {
            let params = {};
            params.date = this.dateValue;
            params.nursingGroupId = this.nursingGroupId;
            var week = new Date(this.dateValue).getDay();//by guo 2019-8-13 10：22修改  传入this.dateValue  获取传入当天日期是星期几
            console.log(week);
            //week 0--星期日  1--星期一 2--星期二  3--星期三  4--星期四  5--星期五 6--星期六
            switch (week) {
                case 0:
                    params.sunDate = this.dateValue;//星期日  
                    break;
                case 1:
                    params.monDate = this.dateValue;//星期一
                    break;
                case 2:
                    params.tueDate = this.dateValue;//星期二
                    break;
                case 3:
                    params.wedDate = this.dateValue;//星期三
                    break;
                case 4:
                    params.thuDate = this.dateValue;//星期四
                    break;
                case 5:
                    params.friDate = this.dateValue;//星期五
                    break;
                default:
                    params.satDate = this.dateValue;//星期六
            }
            console.log(params, "查询房间详情--------");
            this.classesOptions = [];//请求之前清空数据，防止数据累加
            this.nursingWithRoomList = [];//请求之前清空数据，防止数据累加
            this.newAllNursingRoomList = [];//请求之前清空数据，防止数据累加
            // this.$postJson('omc/roomAssignment/select', params).then(res => {
            //     console.log(res, "查询房间详情成功------------");
            //     res.result.forEach((item, index) => {
            //         console.log(item);
            //         let itemObj = {};
            //         itemObj.omcShifts = item.omcShifts;
            //         this.classesOptions.push(itemObj);
            //     })
            //     console.log(this.classesOptions, '__++++++++++++')
            //     //by guo 2019-12-22-14:42添加setTimeout
            //     setTimeout(() => {
            //         this.classesOptions.forEach(classes => {
            //             console.log(classes, "classes------")
            //             classes.showRoomImg = false;
            //             classes.isRoomTrueA = false;
            //             classes.isRoomTrueB = true;
            //             if (this.roomAllocation.classes == classes.omcShifts.id) {
            //                 classes.omcShifts.userList.forEach(temp => {
            //                     let nursingWithRoomObj = {};
            //                     nursingWithRoomObj.userid = temp.userid;
            //                     nursingWithRoomObj.realname = temp.realname;
            //                     nursingWithRoomObj.roomList = temp.roomList;
            //                     this.nursingWithRoomList.push(nursingWithRoomObj)
            //                     temp.roomList.forEach(qat => {
            //                         let newAllNursingRoomObj = {};
            //                         newAllNursingRoomObj.userId = temp.userid * 1;
            //                         newAllNursingRoomObj.realName = temp.realname;
            //                         newAllNursingRoomObj.roomId = qat.roomId * 1;
            //                         this.newAllNursingRoomList.push(newAllNursingRoomObj);
            //                     })
            //                 })
            //             }
            //         })
            //     }, 0)
            //     console.log(this.newAllNursingRoomList, "左边所有的护工和房间的数据")
            //     console.log(this.classesOptions, this.nursingWithRoomList, "不同的护工及其房间")
            //     //利用reduce方法遍历数组,reduce第一个参数是遍历需要执行的函数，第二个参数是item的初始值  去重
            //     var obj = {};
            //     this.nursingWithRoomList = this.nursingWithRoomList.reduce(function (item, next) {
            //         obj[next.userid] ? '' : obj[next.userid] = true && item.push(next);
            //         return item;
            //     }, []);
            // })
        },

        /* 
            dialog模态框中班次默认被选中的
        */
        defaultSelectClasses() {
            let params = {};
            params.date = this.dateValue;
            params.nursingGroupId = this.nursingGroupId;
            console.log(this.dateValue, "this.dateValue-----")
            var week = new Date(this.dateValue).getDay();//by guo 2019-8-13 10：22修改  传入this.dateValue 获取传入当天日期是星期几
            console.log(week);
            //week 0--星期日  1--星期一 2--星期二  3--星期三  4--星期四  5--星期五 6--星期六
            switch (week) {
                case 0:
                    params.sunDate = this.dateValue;//星期日  
                    break;
                case 1:
                    params.monDate = this.dateValue;//星期一
                    break;
                case 2:
                    params.tueDate = this.dateValue;//星期二
                    break;
                case 3:
                    params.wedDate = this.dateValue;//星期三
                    break;
                case 4:
                    params.thuDate = this.dateValue;//星期四
                    break;
                case 5:
                    params.friDate = this.dateValue;//星期五
                    break;
                default:
                    params.satDate = this.dateValue;//星期六
            }
            console.log(params, "查询房间详情222222--------");
            this.$postJson('omc/roomAssignment/select', params).then(res => {
                if (res.code == 200) {
                    if (res.result.length > 0) {//by guo 2019-8-19  13:53 修改  判断数据是否为空  为空就提示本周暂无排班计划
                        res.result.forEach((item, index) => {
                            console.log(item)
                            if (index == 0) {//下拉框的默认值
                                this.roomAllocation.classes = item.omcShifts.id;
                            }
                        })
                    }
                    //else{//by guo 2019-12-22-17:22注释
                    //     this.$message({message:"本日暂无排班计划",type:"error"})
                    // }
                }

                console.log(this.roomAllocation.classes, 'this.roomAllocation.classes+++++++++++')
            })
        },

        /* 
            选择班次的下拉框change事件
        */
        handleSelectClasses(val) {
            console.log(val);
            this.roomAllocation.classes = val;
            this.queryRoomDetail();
        },

        /* 
            右边负责房间的change事件
        */
        handleChooseRoomList(val) {
            console.log(val);
            this.chooseRoom = val;
            console.log(this.chooseRoom);
            this.deleteBtnShow = this.chooseRoom.length > 0 ? false : true;//当右边负责房间  有被选中时， 删除按钮隐藏
        },

        /* 
            添加房间
        */
        submitFormAddRoom() {
            this.$refs.roomAllocation.validate((valid) => {
                console.log(this.newNursingList, this.newAllNursingRoomList)
                var roomAssList = [];
                //两次循环，得到需要的roomAssList
                this.newNursingList.forEach(temp => {
                    this.chooseRoom.forEach(item => {
                        let roomAssObj = {};
                        roomAssObj.realName = temp.realName;
                        roomAssObj.userId = temp.userId * 1;
                        roomAssObj.roomId = item * 1;
                        roomAssList.push(roomAssObj);
                    })
                })
                console.log(roomAssList, "前");
                this.newAllNursingRoomList.forEach(item => {
                    let roomAssObj = {};
                    roomAssObj.realName = item.realName;
                    roomAssObj.userId = item.userId * 1;
                    roomAssObj.roomId = item.roomId * 1;
                    roomAssList.push(roomAssObj);
                })
                console.log(roomAssList, "后")
                //对象的所有属性相同才能认为相同
                var newObj = [];
                var newStr;
                roomAssList = roomAssList.reduce(function (item, next) {
                    newStr = JSON.stringify(next);
                    newObj.indexOf(newStr) == -1 ? item.push(next) && newObj.push(newStr) : '';
                    return item;
                }, []);
                console.log(roomAssList, "去重后的roomAssList")
                let params = {};
                params.date = this.dateValue;//获取日期
                params.shiftsId = this.roomAllocation.classes * 1;//获取shiftsId
                params.nursingGroupId = this.nursingGroupId * 1;//获取nursingGroupId
                params.roomAssList = roomAssList;
                console.log(params);
                this.$postJson('omc/roomAssignment/save', params).then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message({ message: res.message, type: 'success' })
                    } else {
                        this.$message({ message: res.message, type: 'error' })
                    }
                    this.queryRoomDetail();//刷新左边的数据
                    this.checkedNursing = [];//每次提交完后清空左边的护工数据，防止累加
                    this.checkedRoom = [];//每次提交完后清空左边的房间数据，防止累加
                    this.chooseRoom = [];//每次提交完后清空右边的房间数据，防止累加
                    this.addBtnShow = true;//重置添加按钮状态
                    this.deleteBtnShow = true;//重置删除按钮状态
                })
            })
        },

        /* 
            删除房间
        */
        submitFormDeleteRoom() {
            this.$refs.roomAllocation.validate((valid) => {
                console.log(this.newNursingList, this.newAllNursingRoomList)
                var roomAssList = [];
                var oldRoomAssList = [];
                var newRoomAssList = [];
                //两次循环，得到需要的oldRoomAssList
                this.newNursingList.forEach(temp => {
                    this.checkedRoom.forEach(item => {
                        let roomAssObj = {};
                        roomAssObj.realName = temp.realName;
                        roomAssObj.userId = temp.userId * 1;
                        roomAssObj.roomId = item * 1;
                        oldRoomAssList.push(roomAssObj);
                    })
                })
                console.log(oldRoomAssList, "oldRoomAssList");
                //循环得到，得到需要的newRoomAssList
                this.newAllNursingRoomList.forEach(item => {
                    let roomAssObj = {};
                    roomAssObj.realName = item.realName;
                    roomAssObj.userId = item.userId * 1;
                    roomAssObj.roomId = item.roomId * 1;
                    newRoomAssList.push(roomAssObj);
                })
                console.log(newRoomAssList, "newRoomAssLis")
                //循环去除掉相同项
                for (var i = 0; i < newRoomAssList.length; i++) {
                    var obj = newRoomAssList[i];
                    var realNameA = obj.realName;
                    var userIdA = obj.userId;
                    var roomIdA = obj.roomId;
                    var isExist = false;
                    for (var j = 0; j < oldRoomAssList.length; j++) {
                        var aj = oldRoomAssList[j];
                        var realNameB = aj.realName;
                        var userIdB = aj.userId;
                        var roomIdB = aj.roomId;
                        if (realNameA == realNameB && userIdA == userIdB && roomIdA == roomIdB) {
                            isExist = true;
                            break;
                        }
                    }
                    if (!isExist) {
                        roomAssList.push(obj);
                    }
                }
                console.log(roomAssList, "roomAssList---------");
                let params = {};
                params.date = this.dateValue;//获取日期
                params.shiftsId = this.roomAllocation.classes * 1;//获取shiftsId
                params.nursingGroupId = this.nursingGroupId * 1;//获取nursingGroupId
                params.roomAssList = roomAssList;
                console.log(params);
                this.$postJson('omc/roomAssignment/save', params).then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message({ message: res.message, type: 'success' })
                    } else {
                        this.$message({ message: res.message, type: 'error' })
                    }
                    this.queryRoomDetail();//刷新左边的数据
                    this.checkedNursing = [];//每次提交完后清空左边的护工数据，防止累加
                    this.checkedRoom = [];//每次提交完后清空左边的房间数据，防止累加
                    this.chooseRoom = [];//每次提交完后清空右边的房间数据，防止累加
                    this.addBtnShow = true;//重置添加按钮状态
                    this.deleteBtnShow = true;//重置删除按钮状态
                })
            })
        },

        /* 
            查询护工组负责的房间
        */
        selectRooms() {
            let params = {};
            params.nursingGroupId = this.nursingGroupId * 1;
            this.allNursingRoom = [];//请求数据之前先把数组清空，防止累加
            this.$postForm('omc/group/selectRooms', params).then(res => {
                console.log(res, "查询护工组负责房间成功");
                if (res.result != null) {
                    res.result.forEach((item, index) => {
                        console.log(item, "--------")
                        if (item == null) {//去除数据为null的
                            res.result.splice(index, 1);
                        }
                    })
                }
                console.log(res.result);
                this.allNursingRoom = res.result;
            })
        },


        /* ---------------------------------------膳食服务------------------------------------- */

        /* 
            膳食服务 点击单个单元格
        */
        handleCellClickFoodService(row, column, cell, event) {
            //判断是否点击了编辑 true为点击了
            if (this.isTrue == true) {
                if (column.label == "未用餐老人" && this.foodShow == false) {
                    this.dialogVisibleAddOldman = true;
                    console.log(row, column, cell, event);
                    console.log(row.oldmanId.split('-'))
                    let oldmanId = row.oldmanId.split('-');
                    this.checkedOldMan = oldmanId;
                    this.cellClickFoodType = row.type;
                    console.log(this.cellClickFoodType, this.checkedOldMan, "-----------");
                } else {
                    this.dialogVisibleAddOldman = false;
                }
            }
        },

        /* 
            膳食服务 编辑按钮
        */
        handleFoodEdit() {
            this.foodDisabled = false;
            this.foodShow = false;
            this.isTrue = true;
        },

        /* 
            膳食服务  确定按钮  提交数据
        */
        handleFoodSure() {
            this.foodDisabled = true;
            this.foodShow = true;
            this.isTrue = false;
            var meal = '';
            console.log(this.foodServiceList, "----");
            this.foodServiceList.forEach((item, index) => {
                item.oldmanId = item.oldmanId == "" ? 0 : item.oldmanId;
                item.dietRecords = item.dietRecords == "" ? 0 : item.dietRecords;
                meal += item.type + "ν" + item.oldmanId + "ν" + item.dietRecords + "μ";
            })
            meal = meal.substring(0, meal.length - 1);//去除最后一位的μ
            console.log(meal);
            let params = {};
            params.date = this.dateValue;//获取护理日志的日期
            params.nursingGroupId = this.nursingGroupId;//获取护工组id
            params.meal = meal;//获取膳食信息
            console.log(params);
            this.$postJson('omc/nursinglog/mouthCareSave', params).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.$message({ message: res.message, type: 'success' })
                } else {
                    this.$message({ message: res.message, type: 'error' })
                }
                this.queryFood();//获取膳食服务的早中晚餐
                this.queryNursingLog();//提交数据后数据表格的数据
            })
        },

        /* 
            获取膳食服务的早中晚餐
        */
        queryFood() {
            let params = {};
            params.day = this.dateValue;
            //请求之前将数据初始化，防止数据累加
            this.initFoodData();
            this.$postForm('omc/menu/menuShowAll', params).then(res => {
                console.log(res, "查询食物");
                if (res.code == 200) {
                    res.result.forEach(item => {
                        console.log(item);
                        //判断时间选择器中的时间和获取的时间相同 就获取数据
                        this.foodServiceList.forEach(temp => {
                            if (this.dateValue == item.day) {
                                console.log(this.dateValue == item.day, this.dateValue, item.day)
                                switch (temp.type) {
                                    case 1:
                                        temp.food = item.breakfast;
                                        break;
                                    case 2:
                                        temp.food = item.lunch;
                                        break;
                                    default:
                                        temp.food = item.dinner;
                                }

                            }
                        })
                    })
                    console.log(this.foodServiceList, "*************")
                }
            })
        },



        /* --------------------------------------消毒服务--------------------------------- */

        /* 
            消毒服务的表格 类别的合并
        */
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {//下标从0开始 第一列
                if (rowIndex === 0 || rowIndex === 4 || rowIndex === 8) {//把第1行 4行 第9行的合并
                    //by guo 2019-12-22-12:54修改
                    //if (rowIndex === 0 || rowIndex===5 || rowIndex===10) {//把第1行 第6行 第11行的合并
                    return {//合并第一列 总共5行  //合并第一列 总共5行  by guo 2019-12-22-12:55修改 合并第一列 总共4行
                        // rowspan: 5,
                        rowspan: 4,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },

        /* 
            消毒服务 编辑按钮
        */
        handleDisinfectionEdit() {
            console.log("aaaa")
            this.selectDisabled = false;
            this.disinfectionShow = false;
        },

        /* 
            消毒服务 确定按钮
        */
        handleDisinfectionSure() {
            this.selectDisabled = true;
            this.disinfectionShow = true;
            var disinfection = '';
            console.log(this.disinfectionServices, "#######");
            this.disinfectionServices.forEach((item, index) => {
                console.log(item);
                //每一种type的数据需要用分号;隔开 type为1，2，3   判断 index==4 ，9 ， 14 需要使用分哈隔开 同一种type的用逗号隔开  每一行的数据用 - 隔开
                //传参格式 1-1-1-1-10011,1-2-2-2-10022,1-1-1-1-10011,1-2-2-2-10022;2-1-1-1-10011,2-2-2-2-10022,2-1-1-1-10011,2-2-2-2-10022;3-1-1-1-10011,3-2-2-2-10022,3-1-1-1-10011,3-2-2-2-10022;
                //by guo 2019-12-22-12:52修改
                if (index == 3 || index == 7 || index == 11) {
                    // if(index==4 || index==9 || index==14){
                    disinfection += item.type + '-' + item.method + '-' + item.reagent + '-' + item.time + '-' + item.person + ';';
                } else {
                    disinfection += item.type + '-' + item.method + '-' + item.reagent + '-' + item.time + '-' + item.person + ',';
                }
            })
            console.log(disinfection, '------------')
            let params = {};
            params.date = this.dateValue;//获取日期
            params.nursingGroupId = this.nursingGroupId;//获取护工id
            params.disinfection = disinfection;//获取消毒信息
            console.log(params);
            this.$postJson('omc/nursinglog/disinfectSave', params).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.$message({ message: res.message, type: 'success' })
                } else {
                    this.$message({ message: res.message, type: 'error' })
                }
                this.queryNursingLog();//提交数据后数据表格的数据
            })
        },


        /* -------------------基础--口腔---压疮---康复------整合到一起---------------------- */

        /* 
            所有护理 基础 口腔 压疮 康复 编辑按钮
        */
        handleAllNursingEdit() {
            this.selectDisabledAllNursing = false;
            this.allNursingShow = false;
            this.isTrueSynthesis = true;
        },

        /* 
            所有护理 基础 口腔 压疮 康复 确定按钮
        */
        handleAllNursingSure() {
            this.selectDisabledAllNursing = true;
            this.allNursingShow = true;
            this.isTrueSynthesis = false;
            //判断是哪一个护理的数据提交 
            switch (this.activeName) {
                case "four":
                    this.commonNursingData(this.basicNursing, this.activeName, this.dateValue, this.nursingGroupId * 1, 'omc/nursinglog/basicCareSave');//基础护理
                    break;
                case "five":
                    this.commonNursingData(this.mouthNursing, this.activeName, this.dateValue, this.nursingGroupId * 1, 'omc/nursinglog/mouthCareSave');//口腔护理
                    break;
                case "six":
                    this.commonNursingData(this.pressureSoresNursing, this.activeName, this.dateValue, this.nursingGroupId * 1, 'omc/nursinglog/soreCareSave');//压疮护理
                    break;
                case "seven":
                    this.commonNursingData(this.recoveryNursing, this.activeName, this.dateValue, this.nursingGroupId * 1, 'omc/nursinglog/recoveryTrainSave');//康复训练
                    break;
            }
        },

        /* 
            * 封装公共的 基础 口腔 压疮 康复  提交数据
            * @param introductionCommonNursing  传入的数组
            * @param activeName  选项卡菜单在第几个
            * @param date  护理的日期
            * @parma nursingGroupId护工组id
            * @parma url   请求的url
        */
        commonNursingData(introductionCommonNursing, activeName, date, nursingGroupId, url) {
            var commonNursing = '';
            console.log(introductionCommonNursing, "----");
            introductionCommonNursing.forEach((item, index) => {
                //传参格式  324-121,165;121,166;324,165;121-413,166;121-324,166;324-121-413,165;121-413,166
                item.oldmanId = item.oldmanId == "" ? 0 : item.oldmanId;
                item.person = item.person == "" ? 0 : item.person;
                commonNursing += item.oldmanId + "," + item.person + ";";
            })
            commonNursing = commonNursing.substring(0, commonNursing.length - 1);//去除最后一位的μ
            console.log(commonNursing);
            let params = {};
            params.date = date;//获取护理日志的日期
            params.nursingGroupId = nursingGroupId;//获取护工组id
            switch (activeName) {
                case "four":
                    params.basicNursing = commonNursing;//获取基础护理的信息
                    break;
                case "five":
                    params.mouthCare = commonNursing;//获取口腔护理的信息
                    break;
                case "six":
                    params.bedsoreCare = commonNursing;//获取压疮护理的信息
                    break;
                case "seven":
                    params.recoveryTrain = commonNursing;//获取康复训练的信息
                    break;
            }
            console.log(params);
            this.$postJson(url, params).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.$message({ message: res.message, type: 'success' })
                } else {
                    this.$message({ message: res.message, type: 'error' })
                }
                this.queryNursingLog();//提交数据后表格的刷新
            })
        },

        /* 
            点击 基础 口腔 压疮 康复的老人姓名列 表格的单元格
        */
        handleCellClickAllNursing(row, column, cell, event) {
            //判断编辑按钮是否点击了  
            if (this.isTrueSynthesis == true) {
                //点击的列是老人姓名
                if (column.label == "老人姓名" && this.allNursingShow == false) {
                    console.log(row, column, cell, event);
                    console.log(row.oldmanId.split('-'))
                    let oldmanId = row.oldmanId.split('-');
                    this.checkedOldMan = oldmanId;
                    this.cellClickId = row.id;
                    this.dialogVisibleAddOldman = true;
                } else {
                    this.dialogVisibleAddOldman = false;
                }
            }
        },



        /* ------------------添加老人的缓存数据有5个页面用到------------------------- */
        /* 
            添加老人提交缓存数据   膳食  、基础 、 口腔 、压疮 、 康复
        */
        submitFormAddOldman() {
            console.log("aaaaaa");
            if (this.activeName == "second") {
                //膳食
                this.foodServiceList.forEach(item => {
                    console.log(item);
                    if (this.cellClickFoodType == item.type) {
                        item.oldName = this.oldName;
                        item.oldmanId = this.checkOldmanId;
                        item.oldmanIdNew = this.checkOldmanIdNew;//by guo 2019-11-22-14:30修改  因为后端传的参数变更  10011-10022  变更为 10011:王奶奶-10022:李奶奶
                    }
                })
            } else if (this.activeName == "four") {
                //基础
                this.basicNursing.forEach(item => {
                    console.log(item);
                    if (this.cellClickId == item.id) {
                        item.oldName = this.oldName;
                        item.oldmanId = this.checkOldmanId;
                        item.oldmanIdNew = this.checkOldmanIdNew;//by guo 2019-11-22-14:30修改  因为后端传的参数变更  10011-10022  变更为 10011:王奶奶-10022:李奶奶
                    }
                })
            } else if (this.activeName == "five") {
                //口腔
                this.mouthNursing.forEach(item => {
                    console.log(item);
                    if (this.cellClickId == item.id) {
                        item.oldName = this.oldName;
                        item.oldmanId = this.checkOldmanId;
                        item.oldmanIdNew = this.checkOldmanIdNew;//by guo 2019-11-22-14:30修改  因为后端传的参数变更  10011-10022  变更为 10011:王奶奶-10022:李奶奶
                    }
                })
            } else if (this.activeName == "six") {
                //压疮
                this.pressureSoresNursing.forEach(item => {
                    console.log(item);
                    if (this.cellClickId == item.id) {
                        item.oldName = this.oldName;
                        item.oldmanId = this.checkOldmanId;
                        item.oldmanIdNew = this.checkOldmanIdNew;//by guo 2019-11-22-14:30修改  因为后端传的参数变更  10011-10022  变更为 10011:王奶奶-10022:李奶奶
                    }
                })
            } else if (this.activeName == "seven") {
                //康复
                this.recoveryNursing.forEach(item => {
                    console.log(item);
                    if (this.cellClickId == item.id) {
                        item.oldName = this.oldName;
                        item.oldmanId = this.checkOldmanId;
                        item.oldmanIdNew = this.checkOldmanIdNew;//by guo 2019-11-22-14:30修改  因为后端传的参数变更  10011-10022  变更为 10011:王奶奶-10022:李奶奶
                    }
                })
            }
            console.log(this.foodServiceList, this.basicNursing, this.mouthNursing, this.pressureSoresNursing, this.recoveryNursing, "???????");
            this.dialogVisibleAddOldman = false;
            this.oldName = "";//这里要清空数据  防止数据残留回显  by guo 2019-08-19 11:50 修改   
            this.checkOldmanId = [];
            this.checkOldmanIdNew = [];//by guo 2019-11-22-14:32添加 清空数据
        },

        /* 
            查询老人
        */
        queryOldman() {
            let params = {};
            params.nursingGroupId = this.nursingGroupId * 1;
            console.log(params);
            this.$postJson('omc/monitorlog/selectByName', params).then(res => {
                console.log(res);
                if (res.code == 200) {
                    res.result.forEach(item => {
                        let oldmanCheckboxsObj = {};
                        //这里必须要把Number类型转成String类型  否则老人的checkbox数据不会回显的
                        oldmanCheckboxsObj.oldmanId = String(item.oldmanId);
                        oldmanCheckboxsObj.oldName = item.oldName;
                        this.oldmanCheckboxs.push(oldmanCheckboxsObj);
                    })
                    console.log(this.oldmanCheckboxs);
                }
            })
        },

        /* 
            所有老人的checkbox选取
        */
        handleCheckedOldMan(val) {
            console.log(val);
            //去掉数组中空的字符 ""
            for (var i = 0; i < val.length; i++) {
                if (val[i] == "" || val[i] == null || val[i] == undefined) {
                    val.splice(i, 1);
                    i = i - 1;
                }
            }
            console.log(val);
            this.checkedOldMan = val;
            this.checkOldmanId = val.join('-');
            console.log(this.checkedOldMan, this.checkOldmanId);
            var oldName = '';//循环之前清空数据，防止累加
            this.checkedOldMan.forEach(item => {
                console.log(item);
                this.oldmanCheckboxs.forEach(temp => {
                    if (item == temp.oldmanId) {
                        oldName += temp.oldName + ',';
                    }
                })
            })
            this.oldName = oldName.substr(0, oldName.length - 1)
            console.log(this.oldName);
        },



        /* -----------------------查询护理日志的数据-------------------------- */
        /*  
            膳食 、消毒 、基础 、 口腔 、压疮 、 康复
        */
        queryNursingLog() {
            let params = {};
            params.date = this.dateValue;
            params.nursingGroupId = this.nursingGroupId * 1;
            console.log(params);
            this.initFoodData();//请求数据之前先初始化膳食服务表格的数据 ，防止数据累加或者不刷新
            this.initDisinfect();//消毒数据初始化
            this.initBasicNursing();//基础护理初始化
            this.initMouthNursing();//口腔护理初始化
            this.initPressureSoresNursing();//压疮护理初始化
            this.initRecoveryNursing();//康复护理初始化
            this.queryFood();//by guo 2019-12-05 10:16
            // this.$postJson('omc/nursinglog/selectByDate', params).then(res => {
            //     console.log(res, "######");
            //     if (res.code == 200) {
            //         if (res.result != null) {
            //             if (res.result.mealList.length > 0) {
            //                 this.dealFoodData(res.result.mealList);//膳食服务的数据
            //             }
            //             if (res.result.disinfectionList.length > 0) {
            //                 this.dealDisinfectionListData(res.result.disinfectionList);//处理消毒服务的数据
            //             }
            //             if (res.result.basicnursingList.length > 0) {
            //                 this.dealCommonNursingListData(res.result.basicnursingList, this.basicNursing);//处理基础护理的数据
            //             }
            //             if (res.result.mouthcareList.length > 0) {
            //                 this.dealCommonNursingListData(res.result.mouthcareList, this.mouthNursing);//处理口腔护理的数据
            //             }
            //             if (res.result.bedsorecareList.length > 0) {
            //                 this.dealCommonNursingListData(res.result.bedsorecareList, this.pressureSoresNursing);//处理压疮护理的数据
            //             }
            //             if (res.result.recoverytrainList.length > 0) {
            //                 this.dealCommonNursingListData(res.result.recoverytrainList, this.recoveryNursing);//处理康复训练的数据
            //             }
            //         }
            //     }
            // })
        },

        /* 
            处理膳食服务的数据
        */
        dealFoodData(introductionMealList) {
            console.log(introductionMealList, '膳食服务的数据');
            var mealList = [];//用来存放处理后的数据-餐饮类型-饮食记录情况-老人id-老人姓名  
            //第一次循环声明对象 取到 mealObj.remark  饮食记录情况
            introductionMealList.forEach(meal => {
                console.log(meal);
                let mealObj = {};
                mealObj.type = meal.type;//餐饮类型  1早餐  2中餐  3晚餐  
                mealObj.remark = meal.remark;
                mealObj.oldmanId = "";
                mealObj.oldName = "";
                mealObj.oldmanIdNew = "";//by guo 2019-11-22-15:59 添加 新的存放老人id和姓名拼接的字段
                console.log(meal.oldMans)
                //第二次循环拼接 mealObj.oldmanId   老人的id
                meal.oldMans.forEach(mealOldMans => {
                    console.log(mealOldMans, "---");
                    mealObj.oldmanId += mealOldMans + '-';
                    //第三层循环 判断 mealOldMans==oldman.oldmanId 取到 mealObj.oldName 老人姓名
                    this.oldmanCheckboxs.forEach(oldman => {
                        console.log(oldman);
                        if (mealOldMans == oldman.oldmanId) {
                            //mealObj.oldName+=oldman.oldName+',';//by guo 2019-11-23-15:07修改  注释掉  回显的老人姓名历史数据不可以修改数据
                            mealObj.oldmanIdNew += oldman.oldmanId + ':' + oldman.oldName + '-';//by guo 2019-11-22-16:02添加
                        }
                    })
                })
                //by guo 2019-11-23-15:16添加  回显的老人姓名
                meal.oldManNameList.forEach(oldManName => {
                    mealObj.oldName += oldManName + ','
                })
                mealObj.oldmanId = mealObj.oldmanId.substring(0, mealObj.oldmanId.length - 1);//去除最后一位的 '-'
                mealObj.oldName = mealObj.oldName.substring(0, mealObj.oldName.length - 1);//去除最后一位的 ','
                mealObj.oldmanIdNew = mealObj.oldmanIdNew.substring(0, mealObj.oldmanIdNew.length - 1);//去除最后一位的 '-' by guo 2019-11-22-16:02添加
                mealList.push(mealObj);
            })
            console.log(mealList, "meallist");
            console.log(this.foodServiceList, this.oldmanCheckboxs, "*******");

            //第一层循环this.foodServiceList数据源  
            this.foodServiceList.forEach(item => {
                //第二次循环处理存放膳食信息需要的回显数据
                mealList.forEach(temp => {
                    //判断两者餐饮类型是否相同 
                    if (item.type == temp.type) {
                        item.oldName = temp.oldName;
                        item.oldmanId = temp.oldmanId;
                        item.dietRecords = temp.remark;
                        item.oldmanIdNew = temp.oldmanIdNew;//by guo 2019-11-22-16:16添加
                    }
                })
            })
            console.log(this.foodServiceList, "处理之后的膳食服务的数据-------")
        },

        /* 
            处理消毒服务的数据
        */
        dealDisinfectionListData(disinfectionList) {
            console.log(disinfectionList, "消毒服务的数据");
            //第一次循环判断type 类型   1 ， 2 ， 3
            disinfectionList.forEach(item => {
                if (item.type == 1) {
                    console.log(item.disList, "type=1")
                    //第二 三层循环 通过 temp.type==1 && i==j  得到对应的值
                    item.disList.forEach((dis, i) => {
                        this.disinfectionServices.forEach((temp, j) => {
                            if (temp.type == 1 && i == j) {
                                temp.method = dis.way;
                                temp.reagent = dis.reagent;
                                temp.time = dis.time;
                                temp.person = dis.userId * 1;//String类型转成Number类型 否则会显示成String型的userId  而不是显示oldName
                                //temp.person=dis.userId;// by guo 2019-8-14 修改  护工姓名
                                temp.personNew = dis.userId + ':' + dis.userName;//by guo 2019-11-23-14:33修改
                                temp.userName = dis.userName;//by guo 2019-11-23-16:01添加  回显护工的姓名
                            }
                        })
                    })
                } else if (item.type == 2) {
                    console.log(item.disList, "type=2")
                    item.disList.forEach((dis, i) => {
                        this.disinfectionServices.forEach((temp, j) => {
                            //因为type==2时j的循环初始值是从5开始的 ，隐藏i需要+5
                            // by guo 2019-12-22-12:56修改  因为type==2时j的循环初始值是从4开始的 ，隐藏i需要+4
                            if (temp.type == 2 && i + 4 == j) {
                                //if(temp.type==2 && i+5==j){
                                temp.method = dis.way;
                                temp.reagent = dis.reagent;
                                temp.time = dis.time;
                                temp.person = dis.userId * 1;//String类型转成Number类型 否则会显示成String型的userId  而不是显示oldName
                                //temp.person=dis.userId;// by guo 2019-8-14 修改  护工姓名
                                temp.personNew = dis.userId + ':' + dis.userName;//by guo 2019-11-23-14:33修改
                                temp.userName = dis.userName;//by guo 2019-11-23-16:01添加  回显护工的姓名
                            }
                        })
                    })
                } else if (item.type == 3) {
                    console.log(item.disList, "type=3")
                    item.disList.forEach((dis, i) => {
                        this.disinfectionServices.forEach((temp, j) => {
                            //因为type==3时j的循环初始值是从10开始的 ，隐藏i需要+10
                            // by guo 2019-12-22-12:56修改  因为type==2时j的循环初始值是从8开始的 ，隐藏i需要+8
                            if (temp.type == 3 && i + 8 == j) {
                                //if(temp.type==3 && i+10==j){
                                temp.method = dis.way;
                                temp.reagent = dis.reagent;
                                temp.time = dis.time;
                                temp.person = dis.userId * 1;//String类型转成Number类型 否则会显示成String型的userId  而不是显示oldName
                                //temp.person=dis.userId;// by guo 2019-8-14 修改  护工姓名
                                temp.personNew = dis.userId + ':' + dis.userName;//by guo 2019-11-23-14:33修改
                                temp.userName = dis.userName;//by guo 2019-11-23-16:01添加  回显护工的姓名
                            }
                        })
                    })
                }
            })
            console.log(this.disinfectionServices, "处理之后的消毒服务的数据");
        },


        /* 
            封装公共的处理  基础 、 口腔 、压疮 、 康复的表格回显数据
            *parma introductionCommonnursingList  传入的从后端请求到的数组
            *parma introductionInitCommonData   传入的初始化的每一个护理的值
        */
        dealCommonNursingListData(introductionCommonnursingList, introductionInitCommonData) {
            console.log(introductionCommonnursingList, "公共的护理的数据");
            var commonNursingList = [];//用来存放处理后的数据--老人id-老人姓名 ---负责人id
            introductionCommonnursingList.forEach((item, i) => {
                console.log();
                let commonNursingObj = {};
                commonNursingObj.userId = item.userId * 1;//String类型转成Number类型 否则会显示成String型的userId  而不是显示oldName
                //commonNursingObj.userId=item.userId;//不需要转  因为转的是字符串  和平板上对应  
                commonNursingObj.oldmanId = "";
                commonNursingObj.oldmanId = "";
                commonNursingObj.oldName = "";
                commonNursingObj.id = i + 1;
                commonNursingObj.oldmanIdNew = "";//by guo 2019-11-22-15:59 添加 新的存放老人id和姓名拼接的字段
                commonNursingObj.personNew = "";//by guo 2019-11-22-15:59 添加 新的存放护工id和姓名拼接的字段
                commonNursingObj.userName = "";//by guo 2019-11-23-16:37 添加  新的存放回显护工姓名的字段
                console.log(item.oldMans)
                //第二次循环拼接 mealObj.oldmanId   老人的id
                item.oldMans.forEach(temp => {
                    console.log(temp, "---");
                    commonNursingObj.oldmanId += temp + '-';
                    //第三层循环 判断 temp==oldman.oldmanId 取到 commonNursingObj.oldName 老人姓名
                    this.oldmanCheckboxs.forEach(oldman => {
                        console.log(oldman);
                        if (temp == oldman.oldmanId) {
                            //commonNursingObj.oldName+=oldman.oldName+','; //by guo 2019-11-23-15:07修改  注释掉  回显的老人姓名历史数据不可以修改数据
                            commonNursingObj.oldmanIdNew += oldman.oldmanId + ':' + oldman.oldName + '-';//by guo 2019-11-22-16:02添加
                        }
                    })
                })
                //by guo 2019-11-23-15:16添加  回显的老人姓名
                item.oldManNameList.forEach(oldManName => {
                    commonNursingObj.oldName += oldManName + ','
                })
                commonNursingObj.personNew = item.userId * 1 + ":" + item.userName;
                commonNursingObj.oldmanId = commonNursingObj.oldmanId.substring(0, commonNursingObj.oldmanId.length - 1);//去除最后一位的 '-'
                commonNursingObj.oldName = commonNursingObj.oldName.substring(0, commonNursingObj.oldName.length - 1);//去除最后一位的 ','
                commonNursingObj.oldmanIdNew = commonNursingObj.oldmanIdNew.substring(0, commonNursingObj.oldmanIdNew.length - 1);//去除最后一位的 '-' by guo 2019-11-22-16:02添加
                commonNursingObj.userName = item.userName;//by guo 2019-11-23-16:01添加  回显护工的姓名
                commonNursingList.push(commonNursingObj);
            })
            console.log(commonNursingList, "commonNursingList");
            console.log(introductionInitCommonData, this.oldmanCheckboxs, "*******");
            //第一层循环this.basicNursing数据源  
            introductionInitCommonData.forEach(item => {
                //第二次循环处理存放基础护理信息需要的回显数据
                commonNursingList.forEach(temp => {
                    if (item.id == temp.id) {
                        item.oldName = temp.oldName;
                        item.oldmanId = temp.oldmanId;
                        item.person = temp.userId;
                        item.oldmanIdNew = temp.oldmanIdNew;//by guo 2019-11-22-16:16添加
                        item.personNew = temp.personNew;//by guo 2019-11-22-16:16添加
                        item.userName = temp.userName;//by guo 2019-11-23-16:01添加  回显护工的姓名
                    }
                })
            })
            console.log(introductionInitCommonData, "处理之后的护理的数据-------")
        },


        /* ----------------------初始化表格的数据------------------------ */
        /* 
            初始化膳食服务   点击上一天或者下一天时 防止数据不刷新
        */
        initFoodData() {
            this.foodServiceList = [
                { type: 1, typeName: "早餐", food: "", oldName: "", oldmanId: "", dietRecords: "", oldmanIdNew: "" },
                { type: 2, typeName: "中餐", food: "", oldName: "", oldmanId: "", dietRecords: "", oldmanIdNew: "" },
                { type: 3, typeName: "晚餐", food: "", oldName: "", oldmanId: "", dietRecords: "", oldmanIdNew: "" }
            ];
        },

        /* 
            初始化消毒服务  点击上一天或者下一天时 防止数据不刷新
        */
        initDisinfect() {
            this.disinfectionServices = [
                { type: 1, typeName: "消毒柜", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 1, typeName: "消毒柜", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 1, typeName: "消毒柜", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 1, typeName: "消毒柜", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                // {type:1,typeName:"消毒柜",method:0,reagent :0,time:0,person:0,personNew:"",userName:"请选择"},
                { type: 2, typeName: "洗抹", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 2, typeName: "洗抹", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 2, typeName: "洗抹", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 2, typeName: "洗抹", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                // {type:2,typeName:"洗抹",method:0,reagent :0,time:0,person:0,personNew:"",userName:"请选择"},
                { type: 3, typeName: "其他", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 3, typeName: "其他", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 3, typeName: "其他", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                { type: 3, typeName: "其他", method: 0, reagent: 0, time: 0, person: 0, personNew: "", userName: "请选择" },
                // {type:3,typeName:"其他",method:0,reagent :0,time:0,person:0,personNew:"",userName:"请选择"}
            ];
        },

        /* 
            初始化基础护理   点击上一天或者下一天时 防止数据不刷新
        */
        initBasicNursing() {
            this.basicNursing = [
                { id: 1, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 2, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 3, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 4, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 5, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 6, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 7, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
            ];
        },

        /* 
            初始化口腔护理
        */
        initMouthNursing() {
            this.mouthNursing = [
                { id: 1, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 2, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 3, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 4, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 5, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 6, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 7, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
            ];
        },

        /* 
            初始化压疮护理
        */
        initPressureSoresNursing() {
            this.pressureSoresNursing = [
                { id: 1, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 2, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 3, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 4, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 5, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 6, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 7, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
            ];
        },

        /* 
            初始化康复训练
        */
        initRecoveryNursing() {
            this.recoveryNursing = [
                { id: 1, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 2, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 3, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 4, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 5, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 6, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
                { id: 7, oldmanId: "", oldName: "", person: 0, oldmanIdNew: "", personNew: "", userName: "请选择" },
            ];
        },



        /* -----------------------负责人的数据-------------------------- */
        /* 
            获取该班组的护工  
        */
        selectById() {
            let params = {};
            params.nursingGroupId = this.nursingGroupId * 1;
            params.pageNo = "";
            params.pageSize = "";
            console.log(params);
            this.personOptions = [{ realName: "请选择", userId: 0 }]//先初始化，防止累加
            this.$postJson('omc/group/selectById', params).then(res => {
                console.log(res, '-----------');
                res.result.list.forEach(item => {
                    let personObj = {};
                    personObj.realName = item.realName;
                    personObj.userId = item.userId * 1;//String类型转成Number类型 否则会显示成String型的userId  而不是显示oldName
                    //personObj.userId=item.realName;//by guo 2019-08-14 修改
                    this.personOptions.push(personObj);
                })
                console.log(this.personOptions, "this.personOptions-----*********")
            })
        },

        /* 
            获取所有的护工组
        */
        selectShowAll() {
            //请求数据之前先把数据清空
            this.groupTabsList = [];
            this.$postJson('omc/group/selectShowAll').then((res) => {
                console.log(res);
                if (res.result.length > 0) {
                    res.result.forEach((item, index) => {
                        if (index == 0) {//获取默认初始值
                            this.groupActiveName = String(item.id);//获取tab选项卡默认选中的第一个
                            this.nursingGroupId = String(item.id);//获取护工组id的默认第一个
                        }
                        let tabsObj = {};
                        tabsObj.nursingGroupId = String(item.id);
                        tabsObj.name = item.name;
                        this.groupTabsList.push(tabsObj);
                    })
                    //by guo 2019-11-02-14:09修改   将方法放在这里执行  
                    this.selectById();//查询该护工组护工
                    this.queryRoom();//查询房间
                    this.queryRoomDetail();//获取房间详情信
                    this.defaultSelectClasses();//查询下拉框默认被选中的班次
                    this.queryOldman();//查询膳食服务的老人
                    this.queryNursingLog();//查询护理日志
                    this.selectRooms();//查询护工组负责房间
                }
                console.log(this.groupTabsList, "所有的护工组--------");
            })
        },

        /* ------------------------  调用接口查询消毒的方法和试剂  ------------------------ */
        /* by guo 2019-10-30 10:23  添加 */
        queryDictSubListByDictCode(dictCode) {
            this.methodOptions = [];//清空数据
            this.reagentOptions = [];
            this.$postJson('mdc/dict/queryDictSubListByDictCode/' + dictCode).then(res => {
                console.log(res, "-------");
                if (res.result != null || res.result.length > 0) {
                    res.result.forEach(item => {
                        let obj = new Object();
                        obj.value = item.id * 1;//将String类型转成Number类型  否则就会显示id 而不是dicName  
                        obj.label = item.dictName;
                        //通过传进来的参数来判断来判断将数据添加进哪一个数组中 
                        if (dictCode == 'method') {
                            this.methodOptions.push(obj);
                        }
                        if (dictCode == 'reagent') {
                            this.reagentOptions.push(obj);
                        }
                    })
                }
            })
        },

        /* 
            修改table tr行的背景色
        */
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                return "background-color: #ffffff";
            } else {
                return "background-color: #e4f5f8";
            }
        },

        /* 
                修改table header的背景色
            */
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
            }
        },

        /* 
            初始化 消毒服务 方法
        */
        initialMethodOptions() {
            var method = ["请选择", "冲洗", "开水煮", "消毒柜", "暴晒清洗", "扫拖", "冲刷", "浸泡"]
            for (var i = 0; i < method.length; i++) {
                var item = {}
                item.value = i
                item.label = method[i]
                this.methodOptions.push(item)
            }
        },

        /* 
            初始化 消毒服务 试剂
        */
        initialReagentOptions() {
            var reagent = ["请选择", "84消毒液", "度米分", "红外线", "紫外线", "洁厕剂"]
            for (var i = 0; i < reagent.length; i++) {
                var item = {}
                item.value = i
                item.label = reagent[i]
                this.reagentOptions.push(item)
            }
        },

        /* 
            初始化 消毒服务时间
        */
        initialTimeOptions() {
            var time = ["请选择", "0:00-1:00", "1:00-2:00", "2:00-3:00", "3:00-4:00", "4:00-5:00", "5:00-6:00", "6:00-7:00", "7:00-8:00", "8:00-9:00", "9:00-10:00", "10:00-11:00", "11:00-12:00", "12:00-13:00", "13:00-14:00", "14:00-15:00", "15:00-16:00", "16:00-17:00", "17:00-18:00", "18:00-19:00", "19:00-20:00", "20:00-21:00", "21:00-22:00", "22:00-23:00", "23:00-24:00"]
            for (var i = 0; i < time.length; i++) {
                var item = {}
                item.value = i
                item.label = time[i]
                this.timeOptions.push(item)
            }
        },

    },
    created() {
        // this.initialMethodOptions();
        // this.initialReagentOptions();
        this.initialTimeOptions();
        this.selectShowAll();//查询所有的护工组
        this.queryDictSubListByDictCode('method');//查询消毒方法 by guo 2019-10-30 10:25
        this.queryDictSubListByDictCode('reagent');//查询消毒试剂 by guo 2019-10-30 10:25
    },
    mounted() {
        //延迟加载  因为要等nursingGroup加载完成  才能去请求下面的
        this.$nextTick(() => {
            setTimeout(() => {
                //this.selectById();//查询该护工组护工  by guo 2019-11-02-14:10 修改 将方法放在selectShowAll的方法中执行
                //this.queryRoom();//查询房间  by guo 2019-11-02-14:10 修改 将方法放在selectShowAll的方法中执行
                //this.queryFood();//查询食物  by guo 2019-11-02-14:10 修改 将方法放在selectShowAll的方法中执行
                //this.queryOldman();//查询膳食服务的老人
                //this.queryNursingLog();//查询护理日志
                //this.selectRooms();//查询护工组负责房间
            }, 300)
            setTimeout(() => {
                //this.defaultSelectClasses();//查询下拉框默认被选中的班次  by guo 2019-11-02-14:10 修改 将方法放在selectShowAll的方法中执行
            }, 300)
            setTimeout(() => {
                //this.queryRoomDetail();//获取房间详情信  by guo 2019-11-02-14:10 修改 将方法放在selectShowAll的方法中执行
            }, 500)
        })
    },
}
</script>
<style lang="scss" scoped>
.nursinglog {
    min-width: 1360px;
    min-height: 700px;
    background: #FEFEFE;

    .hoverColor:hover {
        background: rgb(153, 176, 206);
        cursor: pointer;
    }

    .hoverColorSynthesis:hover {
        background: rgb(153, 176, 206);
        cursor: pointer;
    }

    .room {
        width: 90%;
    }

    .roomitem {
        border-radius: 8px;
        width: 250px;
        height: 267px;
        border: 2px #efefef solid;
        margin: 25px 32px 25px 10px;
        float: left;

        .changfx {
            height: 37px;
            line-height: 20px;
            background-color: #efefef;

            h5 {
                display: inline-block;
                margin: 8px;
                color: #252a36;
                font-size: 18px;
            }

            img {
                margin: 8px;
                float: right;
                cursor: pointer;
            }
        }

        .classDiv {
            .line_bh {
                width: 250px;
                // margin-left: 15px;
                // margin-right: 0px;
                margin: 15px 0 15px 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .shiftname {
                    width: 80px;
                    line-height: 28px;
                    // float: left;
                    // overflow:hidden;
                    // text-overflow:ellipsis;
                    // white-space: nowrap;
                }

                .qq_width {
                    // float:right;
                    // width: 180px;
                    flex: 1;
                    line-height: 28px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    .realname {
                        width: 60px;
                        margin-left: 5px;
                        // overflow:hidden;
                        // text-overflow:ellipsis;
                        // white-space: nowrap;
                    }
                }

            }
        }
    }

    .roomInfo {
        border: 1px solid #ccc;

        .roomInfoText {
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-bottom: 1px solid #ccc;
        }

        .roomInfoContent {
            height: 260px;
            overflow-y: auto;
            overflow-x: hidden;

            .checkboxRoom {
                width: 40%;
                margin: 3px auto;

            }

            .buildingName {
                margin-top: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }

            .roomNo {
                width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }

            .roomListA {
                opacity: 1;
            }

            .roomListB {
                display: none;
            }
        }
    }

    .btn {
        height: 300px;

        .addBtn {
            padding-top: 100px;
        }

        .deleteBtn {
            margin-top: 20px;
        }
    }

    ul,
    li,
    h4,
    h5 {
        margin: 0;
        padding: 0;
    }

    li {
        list-style: none;
    }
}

::v-deep .el-table .el-table__body td {
    padding: 0px !important;
}

::v-deep .el-table .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

//修改 tabs content的高度
::v-deep .el-tabs .el-tabs__content {
    min-height: 500px !important;
    padding-bottom: 100px;
}

//修改tabs  下划线的
::v-deep .group-isactive .el-tabs__nav .el-tabs__active-bar {
    position: absolute !important;
    bottom: 0 !important;
    left: 0 !important;
    height: 2px !important;
    background-color: #409EFF !important;
    z-index: 1 !important;
    -webkit-transition: -webkit-transform .3s cubic-bezier(.645, .045, .355, 1) !important;
    transition: -webkit-transform .3s cubic-bezier(.645, .045, .355, 1) !important;
    transition: transform .3s cubic-bezier(.645, .045, .355, 1) !important;
    transition: transform .3s cubic-bezier(.645, .045, .355, 1) !important;
    transition: -webkit-transform .3s cubic-bezier(.645, .045, .355, 1) !important;
    transition: transform .3s cubic-bezier(.645, .045, .355, 1) !important;
    transition: -webkit-transform .3s cubic-bezier(.645, .045, .355, 1) !important;
    list-style: none !important;
}</style>

